import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

const statusColorMap = {
  active: 'success',
  approved: 'success',
  resolved: 'success',
  completed: 'success',
  executed: 'success',
  placeholder_ready: 'info',
  queued: 'info',
  executing: 'info',
  pending: 'warning',
  pending_approval: 'warning',
  awaiting_execution: 'warning',
  reserved: 'warning',
  stalled: 'warning',
  blocked: 'warning',
  'awaiting review': 'warning',
  rejected: 'error',
  failed: 'error',
  cancelled: 'default',
  disputed: 'error',
  degraded: 'warning',
  shadow: 'secondary',
  enforced: 'primary',
  'outbox pending': 'info',
  'outbox failed': 'error',
};

export default function AdminStatusChip({ status, size = 'small', variant = 'soft' }) {
  const color = statusColorMap[status] || 'default';

  return (
    <Chip
      label={status.replace(/_/g, ' ')}
      color={color}
      size={size}
      variant={variant === 'soft' ? 'filled' : variant}
      sx={{
        textTransform: 'capitalize',
        fontWeight: 700,
        letterSpacing: 0.2,
      }}
    />
  );
}

AdminStatusChip.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  status: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['filled', 'outlined', 'soft']),
};
